import React, { MouseEventHandler, useState } from "react";
import styles from "./index.module.scss";
import { Button } from "../../../login/components";

const questions = [
  {
    question:
      "Let us start off with a straightforward one. The Great War lasted for _____ days of fighting.",
    options: [16, 18, 20, 11],
    correctOption: 18,
  },
  {
    question: "In all, how many sons or daughters did Kunti give birth to?",
    options: [5, 4, 6, 3],
    correctOption: 6,
  },
  {
    question: "How many heads of Lord Krishna showed in his 'vishwaroop'",
    options: [5, 6, 9, 11],
    correctOption: 9,
  },
  {
    question: "Who was the real father of Arjuna?",
    options: ["Vayu", "Indra", "Surya", "Yama"],
    correctOption: "Indra",
  },
  {
    question:
      "Abhimanyu, the son of Arjuna and Subhadra, was murdered while trying to break into a vyuha. Which vyuha was it?",
    options: ["Sukhimukhavyha", " Chakravyuha", " Makaravyuha", " Sakatavyuha"],
    correctOption: "Chakravyuha",
  },
  {
    question:
      "Which one of the following rules should be followed while fighting with the mace?",
    options: [
      "One should strike only when he is struck by the opponent.",
      "The opponent should not be hit below the hips.",
      "One should not withdraw from the fight.",
      "The opponent's head should not be hit.",
    ],
    correctOption: "Chakravyuha",
  },
];

export interface QuestionProps {
  close?: () => void;
  changeStreak?: (strk: any) => void;
  bonus?: Boolean;
  setBns?: () => void;
}

function Question({ close, changeStreak, bonus, setBns }: QuestionProps) {
  const [streak, setStreak] = useState(0);
  const [wrong, setWrong] = useState(false);

  const answerQuestion = (ans: any) => {
    if (ans === questions[streak].correctOption) {
      setStreak(streak + 1);
    } else {
      setWrong(true);
      // changeStreak(streak);
      // close();
    }
  };

  if (bonus) {
    return (
      <div className={styles.questionDialog}>
        <div className={styles.questionContainer}>
          {!wrong && (
            <>
              <div className={styles.close} onClick={close}>
                Close
              </div>
              <h1>Bonus Question</h1>
              {/* <h2 className={styles.streakText}>Streak: {streak}</h2> */}
              <div className={styles.questionBox}>
                <h2>
                  Let us go back to the beginning - who was the father of
                  Bhishma?
                </h2>
                <ul>
                  <li
                    onClick={() => {
                      close && close();
                      setBns && setBns();
                    }}
                  >
                    Vichitraveerya
                  </li>
                  <li
                    onClick={() => {
                      alert("DONE");

                      changeStreak && changeStreak(3);
                      setBns && setBns();
                    }}
                  >
                    Shantanu
                  </li>
                  <li
                    onClick={() => {
                      close && close();
                      setBns && setBns();
                    }}
                  >
                    Chitrasena
                  </li>
                  <li
                    onClick={() => {
                      close && close();
                      setBns && setBns();
                    }}
                  >
                    Soora
                  </li>
                </ul>

                {/* <h2>{questions[streak].question}</h2>
              <ul>
                {questions[streak].options.map((item, index) => (
                  <li
                    onClick={() => {
                      answerQuestion(item);
                    }}
                    key={index}
                  >
                    {item}
                  </li>
                ))}
              </ul> */}
              </div>
            </>
          )}
          {wrong && (
            <div className={styles.wrong}>
              <h1>Ahh!! You got that wrong</h1>
              <video
                controls
                src="https://res.cloudinary.com/dxuiu1h8i/video/upload/v1624434728/pachasi/WhatsApp_Video_2021-06-23_at_12.22.45_plg5ce.mp4"
              ></video>
              <p>
                Vishvarupa has innumerable forms, eyes, faces, mouths and arms.
                All creatures of the universe are part of him. He is the
                infinite universe, without a beginning or an end. He contains
                peaceful as well as wrathful forms
              </p>
              <Button
                onClick={() => {
                  changeStreak && changeStreak(streak);
                  close && close();
                }}
                name={"Okay"}
              />
            </div>
          )}
        </div>
      </div>
    );
  }

  return (
    <div className={styles.questionDialog}>
      <div className={styles.questionContainer}>
        {!wrong && (
          <>
            <div className={styles.close} onClick={close}>
              Close
            </div>
            <h1>Question</h1>
            <h2 className={styles.streakText}>Streak: {streak}</h2>
            <div className={styles.questionBox}>
              <h2>{questions[streak].question}</h2>
              <ul>
                {questions[streak].options.map((item, index) => (
                  <li
                    onClick={() => {
                      answerQuestion(item);
                    }}
                    key={index}
                  >
                    {item}
                  </li>
                ))}
              </ul>
            </div>
          </>
        )}
        {wrong && (
          <div className={styles.wrong}>
            <h1>Ahh!! You got that wrong</h1>
            <video
              controls
              src="https://res.cloudinary.com/dxuiu1h8i/video/upload/v1624434728/pachasi/WhatsApp_Video_2021-06-23_at_12.22.45_plg5ce.mp4"
            ></video>
            <p>
              Vishvarupa has innumerable forms, eyes, faces, mouths and arms.
              All creatures of the universe are part of him. He is the infinite
              universe, without a beginning or an end. He contains peaceful as
              well as wrathful forms
            </p>
            <Button
              onClick={() => {
                changeStreak && changeStreak(streak);
                close && close();
              }}
              name={"Okay"}
            />
          </div>
        )}
      </div>
    </div>
  );
}

export default Question;
